import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Compass } from "lucide-react";

export default function ProtectedRoute() {
  const { user } = useAuth();

  if (user === null) {
    return (
      <div className="min-h-screen flex flex-col items-center justify-center gap-3 bg-patria-sage" data-testid="auth-loading">
        <Compass className="h-8 w-8 text-patria-green animate-pulse" />
        <p className="text-patria-muted text-sm">Loading COMPASS…</p>
      </div>
    );
  }
  if (user === false) return <Navigate to="/login" replace />;
  return <Outlet />;
}
